import React, { useEffect, useState } from 'react';
import { Button, Modal } from 'antd';
import { useLocation, useNavigate } from 'react-router-dom';
// import {useParams} from "react-router-dom"; // ❌ COMENTADO
// import { Row, Typography, Breadcrumb} from 'antd'; // ❌ COMENTADO
// import { ProductsData } from '../../../data/product/productsData'; // ❌ COMENTADO
import '../styles.scss';
// import { useNavigate } from 'react-router-dom'; // ❌ COMENTADO
// import { CategoriesData } from '../../../data/categories/categoriesData'; // ❌ COMENTADO
import PurchaseForm from '../global_components/PurchaseForm';
// import AppBarMarketPlace from '../global_components/AppBar'; // ❌ COMENTADO - ¿EXISTE?
import TopBar from '../global_components/TopBar2';
import LayoutPage from '../../../layouts/Main';

// eslint-disable-next-line no-unused-vars
//const { Title } = Typography;

export default function CheckoutPage(props) {
  const navigate = useNavigate();
  const location = useLocation();
  const [isLoginGateModalOpen, setIsLoginGateModalOpen] = useState(false);
  const [isAccessBlocked, setIsAccessBlocked] = useState(false);
  
  // eslint-disable-next-line no-unused-vars
  //const productsData = ProductsData;
  // eslint-disable-next-line no-unused-vars
  //const categoriesData = CategoriesData;


  useEffect(() => {
    const query = new URLSearchParams(location.search);
    const rawLoginFlag = (query.get('login') || query.get('requireLogin') || '').toLowerCase();
    const shouldRequestLogin = rawLoginFlag === '1' || rawLoginFlag === 'true' || rawLoginFlag === 'yes';
    const enforceLoginOnRoute = true;
    const shouldValidateSession = enforceLoginOnRoute || shouldRequestLogin;

    if (!shouldValidateSession) return;

    let parsedUser = null;
    try {
      parsedUser = JSON.parse(localStorage.getItem('user') || 'null');
    } catch (error) {
      parsedUser = null;
    }

    const hasUserSession = Boolean(parsedUser?.id && localStorage.getItem('role'));
    const hasToken = Boolean(localStorage.getItem('token'));
    const hasSession = hasUserSession || hasToken;

    if (hasSession) {
      setIsAccessBlocked(false);
      setIsLoginGateModalOpen(false);
      return;
    }

    const explicitRedirect = query.get('redirect') || query.get('redirectTo');
    const cleanedQuery = new URLSearchParams(location.search);
    ['login', 'requireLogin', 'redirect', 'redirectTo'].forEach((param) => cleanedQuery.delete(param));
    const cleanSearch = cleanedQuery.toString();
    const currentPagePath = `${location.pathname}${cleanSearch ? `?${cleanSearch}` : ''}${location.hash || ''}`;

    localStorage.setItem('post_login_redirect', explicitRedirect || currentPagePath);
    setIsAccessBlocked(true);
    setIsLoginGateModalOpen(true);
  }, [location.hash, location.pathname, location.search]);

  const handleLoginRedirect = () => {
    navigate('/login');
  };

  const handleRegisterRedirect = () => {
    navigate('/register');
  };

  return (
    <LayoutPage>
      <Modal
        open={isLoginGateModalOpen}
        onCancel={() => {}}
        footer={null}
        centered
        closable={false}
        maskClosable={false}
        keyboard={false}
        width={420}
        bodyStyle={{ padding: 0 }}
      >
        <div style={{ background: '#0F5197', color: '#fff', padding: '28px 24px', textAlign: 'center' }}>
          <h2 style={{ margin: 0, fontSize: 22, fontWeight: 700 }}>
            Inicia sesion para continuar
          </h2>
          <p style={{ margin: '8px 0 0', fontSize: 14, opacity: 0.95 }}>
            Para continuar con el checkout, primero debes autenticarte.
          </p>
        </div>
        <div style={{ padding: '18px 24px 24px' }}>
          <Button
            type="primary"
            block
            size="large"
            onClick={handleLoginRedirect}
            style={{ background: '#0F5197', borderColor: '#0F5197', fontWeight: 600 }}
          >
            Iniciar sesion
          </Button>
          <Button
            block
            size="large"
            onClick={handleRegisterRedirect}
            style={{ marginTop: 12, fontWeight: 600 }}
          >
            Crear cuenta
          </Button>
        </div>
      </Modal>
      {!isAccessBlocked && (
        <>
          <TopBar title={'Genera tu orden de compra'} categorie={'none'} />
          <PurchaseForm />
        </>
      )}
    </LayoutPage>
  );
}
